/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recent_OrdersInputs */

const vi_dashboard_recent_orders = /** @type {(inputs: Dashboard_Recent_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng gần đây`)
};

/**

* @param {Dashboard_Recent_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_recent_orders = /** @type {((inputs?: Dashboard_Recent_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recent_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_recent_orders(inputs)
});